import { BehaviorSubject } from 'rxjs';
import { ApplicationVersion } from './application-version';

export const newestApplicationVersion$ = new BehaviorSubject<
ApplicationVersion
>(new ApplicationVersion());
